import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getModuleDetails, doModuleCreate, doModuleUpdate 
} from "../../../../redux/module/moduleState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from '../../../../utils/crudSagaHelper';

const ModuleForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			const initialValues = {
				hol_id: recordData.hol_id,
				hol_name: recordData.hol_name,
			    hol_type_id: recordData.hol_type_id,
			};	
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  
			recordData.hol_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="hol_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-4 gap-4">         		            	            
	            	<FormItem className="font-medium mb-2 col-span-2"
		            	name="hol_name"
		                label="Module Name"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Input id="hol_name"/>
		                : <label className="ps-3 dark:text-white">{recordData?.hol_name}</label>
		                }
	            	</FormItem>	  
	            	<FormItem className="font-medium mb-2"
		            	name="hol_type_id"
		                label="Type"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="hol_type_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.moduleTypeList}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.hol_type_name}</label>
		            	}	                
	            	</FormItem> 
	            	
	 			</div>
	 			<CrudButtons baseRoute="/console/modules" mode={mode} recordId={recordData?.hol_id} /> 				 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.module.moduleDetails?.data,
  	requesting: state.module.moduleDetails?.requesting,
  	success: state.module.moduleDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getModuleDetails(id)),
  	doCreate: (data) => dispatch(doModuleCreate(data)),
  	doUpdate: (data) => dispatch(doModuleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleForm);
